import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login'
import AppView from './components/app-view'
import Dashboard from './views/admin/dashboard'
import Admins from './views/admin/admin/Admins'
import User from './views/admin/user/User'
import Order from './views/admin/order/Order'
import Course from './views/admin/basis/Course'
import LogisticsCompany from './views/admin/basis/LogisticsCompany'
import Content from './views/admin/basis/Content'
import updateOrder from "./views/admin/order/updateOrder"
import insertCourse from "./views/admin/basis/insertCourse";
import updateCourse from "./views/admin/basis/updateCourse";
import UserRecord from "./views/admin/user/UserRecord";
import updateUserOrder from "./views/admin/user/updateUserOrder";
import ImportExcel from "./views/admin/order/ImportExcel";
import Users from "./views/admin/Users/Users";
Vue.use(Router)

export default  new Router({
  mode: 'hash', // hash, history
  routes: [
    { path: '/', name: 'Login',component: Login, },
    {
      path: '/admin',
      component: AppView,
      children: [
        { path: '', component: Dashboard, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        // eslint-disable-next-line no-undef
        { path: '/User', component: User, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/Admins', component: Admins, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        // eslint-disable-next-line no-undef
        { path: '/Order', component: Order, meta: { icon: 'fa fa-dashboard', label: 'Dashboard', requireAuth: true } },
        { path: '/Course', component: Course, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/LogisticsCompany', component: LogisticsCompany, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/Content', component: Content, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/updateOrder', component: updateOrder, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/insertCourse', component: insertCourse, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/updateCourse', component: updateCourse, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/UserRecord', component: UserRecord, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/updateUserOrder', component: updateUserOrder, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/ImportExcel', component: ImportExcel, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
        { path: '/Users', component: Users, meta: { icon: 'fa fa-dashboard', label: 'Dashboard' } },
      ]
    }
  ]

})




